// React imports
import { useState, useEffect } from 'react';

// General imports
import _ from 'lodash';
import axios from 'axios';

// MUI imports
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';

// Local imports
import getBaseUrl from '../../GetBaseUrl.js';
import OpportunityPreviewAndSendBase from './OpportunityPreviewAndSendBase.js';

function OpportunityPreviewAndSend(props) {
    return (
        <OpportunityPreviewAndSendBase {...props} />
    )
}

export default OpportunityPreviewAndSend;